<template>
  <div
    :class="{
      'layout-width': [
        'grid',
        'table',
        'selectInputList',
        'tabs',
        'card',
        'editor',
        'batch',
        'divider',
        'html',
      ].includes(record.type),
    }"
  >
    <template v-if="record.type === 'table'">
      <div class="table-box" @click.stop="handleSelectItem(record)">
        <div style="border: none !important; height: 30px !important">
          <p
            style="
              border: none !important;
              text-align: center;
              font-family: SimSun;
              font-size: 10.5pt;
              color: rgba(0, 0, 0, 0.9);
              font-weight: 600;
            "
            class="table-td"
            :colspan="2"
            :rowspan="1"
          >
            乌鲁木齐市疾病预防控制中心
          </p>
        </div>
        <div style="height: 30px !important">
          <p
            style="
              border: none !important;
              text-align: center;
              font-family: SimSun;
              font-size: 15pt;
              color: rgba(0, 0, 0, 0.9);
              font-weight: 600;
            "
            class="table-td"
            :colspan="2"
            :rowspan="1"
          >
            {{ config.templateName || "请在页面设置输入模板名称" }}
          </p>
        </div>
        <div
          style="
            height: 18px !important;
            display: flex;
            justify-content: space-between;
          "
        >
          <p
            style="border: none !important; text-align: left; margin-left: 20px"
            class="table-td"
            :colspan="1"
            :rowspan="1"
          >
            {{ config.controllerNum || "请在页面设置输入受控号" }}
          </p>
          <p
            style="
              border: none !important;
              text-align: right;
              margin-right: 20px;
            "
            class="table-td"
            :colspan="1"
            :rowspan="1"
          >
            第____页共____页
          </p>
        </div>
        <div class="table-div">
          <div
            class="div-tr"
            v-for="(trItem, trIndex) in record.trs"
            v-if="record.trs.type != '2'"
            :key="trIndex"
          >
            <div
              class="div-td"
              v-for="(tdItem, tdIndex) in trItem.tds"
              :key="tdIndex"
              @contextmenu.prevent="
                $emit('handleShowRightMenu', $event, record, trIndex, tdIndex)
              "
              :colspan="tdItem.colSpan"
              v-show="
                (tdItem.colSpan > 0 && tdItem.rowSpan > 0) ||
                (tdItem.colspan && tdItem.rowspan)
              "
              :rowspan="tdItem.rowSpan"
            >
            <draggable
                tag="div"
                style="overflow: hidden"
                class="draggable-box"
                v-bind="{
                  group: 'form-draggable',
                  ghostClass: 'moving',
                  animation: 180,
                  handle: '.drag-move',
                }"
                v-model="tdItem.list"
                @start="$emit('dragStart', $event, tdItem.list)"
                @add="$emit('handleColAdd', $event, tdItem.list)"
              >
                <transition-group
                  tag="div"
                  name="list"
                  :style="{ 'min-height': tdItem.rowspan * 80 - 19 + 'px' }"
                  class="list-main"
                >
                  <layoutItem
                    style="width: 100%"
                    class="drag-move"
                    v-for="item in tdItem.list"
                    :key="item.key"
                    :selectItem.sync="selectItem"
                    :startType="startType"
                    :insertAllowedType="insertAllowedType"
                    :record="item"
                    :hideModel="hideModel"
                    :config="config"
                    @handleSelectItem="handleSelectItem"
                    @handleColAdd="handleColAdd"
                    @handleCopy="$emit('handleCopy')"
                    @handleShowRightMenu="handleShowRightMenu"
                    @handleDelete="$emit('handleDelete')"
                  />
                </transition-group>
              </draggable>
          </div>
          </div>
        </div>
        <!-- <table class="table-layout kk-table-9136076486841527">
          <tr
            :class="{ active: record.key === selectItem.key }"
            style="border: 1px solid #000"
            v-for="(trItem, trIndex) in record.trs"
            v-if="record.trs.type != '2'"
            :key="trIndex"
          >
            <td
              class="table-td"
              v-for="(tdItem, tdIndex) in trItem.tds"
              :key="tdIndex"
              @contextmenu.prevent="
                $emit('handleShowRightMenu', $event, record, trIndex, tdIndex)
              "
              :colspan="tdItem.colSpan"
              v-show="
                (tdItem.colSpan > 0 && tdItem.rowSpan > 0) ||
                (tdItem.colspan && tdItem.rowspan)
              "
              :rowspan="tdItem.rowSpan"
            >
              <draggable
                tag="div"
                style="overflow: hidden"
                class="draggable-box"
                v-bind="{
                  group: 'form-draggable',
                  ghostClass: 'moving',
                  animation: 180,
                  handle: '.drag-move',
                }"
                v-model="tdItem.list"
                @start="$emit('dragStart', $event, tdItem.list)"
                @add="$emit('handleColAdd', $event, tdItem.list)"
              >
                <transition-group
                  tag="div"
                  name="list"
                  :style="{ 'min-height': tdItem.rowspan * 80 - 19 + 'px' }"
                  class="list-main"
                >
                  <layoutItem
                    style="width: 100%"
                    class="drag-move"
                    v-for="item in tdItem.list"
                    :key="item.key"
                    :selectItem.sync="selectItem"
                    :startType="startType"
                    :insertAllowedType="insertAllowedType"
                    :record="item"
                    :hideModel="hideModel"
                    :config="config"
                    @handleSelectItem="handleSelectItem"
                    @handleColAdd="handleColAdd"
                    @handleCopy="$emit('handleCopy')"
                    @handleShowRightMenu="handleShowRightMenu"
                    @handleDelete="$emit('handleDelete')"
                  />
                </transition-group>
              </draggable>
            </td>
          </tr>
        </table> -->
      </div>
    </template>
    <template v-if="record.type === 'layout'">
      <div class="table-div">
          <div
            class="div-tr"
            v-for="(trItem, trIndex) in record.trs"
            v-if="record.trs.type != '2'"
            :key="trIndex"
          >
            <div
              class="div-td"
              v-for="(tdItem, tdIndex) in trItem.tds"
              :key="tdIndex"
              @contextmenu.prevent="
                $emit('handleShowRightMenu', $event, record, trIndex, tdIndex)
              "
              :colspan="tdItem.colSpan"
              v-show="
                (tdItem.colSpan > 0 && tdItem.rowSpan > 0) ||
                (tdItem.colspan && tdItem.rowspan)
              "
              :rowspan="tdItem.rowSpan"
            >
            <draggable
                tag="div"
                style="overflow: hidden"
                class="draggable-box"
                v-bind="{
                  group: 'form-draggable',
                  ghostClass: 'moving',
                  animation: 180,
                  handle: '.drag-move',
                }"
                v-model="tdItem.list"
                @start="$emit('dragStart', $event, tdItem.list)"
                @add="$emit('handleColAdd', $event, tdItem.list)"
              >
                <transition-group
                  tag="div"
                  name="list"
                  :style="{ 'min-height': tdItem.rowspan * 80 - 19 + 'px' }"
                  class="list-main"
                >
                  <layoutItem
                    style="width: 100%"
                    class="drag-move"
                    v-for="item in tdItem.list"
                    :key="item.key"
                    :selectItem.sync="selectItem"
                    :startType="startType"
                    :insertAllowedType="insertAllowedType"
                    :record="item"
                    :hideModel="hideModel"
                    :config="config"
                    @handleSelectItem="handleSelectItem"
                    @handleColAdd="handleColAdd"
                    @handleCopy="$emit('handleCopy')"
                    @handleShowRightMenu="handleShowRightMenu"
                    @handleDelete="$emit('handleDelete')"
                  />
                </transition-group>
              </draggable>
          </div>
          </div>
        </div>
    </template>
    <template v-else-if="record.type == 'VERTICAL'">
      <div class="table-container">
    <!-- 表头 -->
    <div class="table-header">
      <div class="header-row" v-for="(row, rowIndex) in record.rows" :key="rowIndex">
        <div class="cell" v-for="(cell, cellIndex) in row.cells" :key="cellIndex">
          {{ cell.componentName }}
          <!-- 渲染子单元格 -->
          <div class="sub-cell" v-if="cell.cells && cell.cells.length" v-for="(subCell, subCellIndex) in cell.cells" :key="subCellIndex">
            {{ subCell.componentName }}

          </div>
        </div>
      </div>
    </div>

    <!-- 表内容 -->
    <div class="table-body">
      <div class="row" v-for="(row, rowIndex) in record.main" :key="rowIndex">
        <div class="cell" v-for="(cell, cellIndex) in row.cells" :key="cellIndex">
         <span> {{ cell.componentName }}</span>
        </div>
      </div>
    </div>
  </div>
    </template>

    <!-- 表格布局 end -->
    <template v-else>
      <formNode
        :key="record.key"
        :selectItem.sync="selectItem"
        :record="record"
        :config="config"
        :hideModel="hideModel"
        @handleSelectItem="handleSelectItem"
        @handleCopy="$emit('handleCopy')"
        @handleDelete="$emit('handleDelete')"
        @handleShowRightMenu="$emit('handleShowRightMenu')"
      />
    </template>
  </div>
</template>
<script>
/*
 * author kcz
 * date 2019-11-20
 * description 使用递归组件调用自己，生成布局结构及表单
 */
import draggable from "vuedraggable";
import formNode from "./formNode";
import { pluginManager } from "../../../utils/index";
const CheckboxItem = pluginManager.getComponent("checkboxItem").component;
const RadioItem = pluginManager.getComponent("radioItem").component;
// import JSTable from '../../../../../../views/baseInfo/detection/sampling.vue'
import TreeTest from "./tree.vue";

export default {
  name: "layoutItem",
  props: {
    record: {
      type: Object,
      required: true,
    },
    selectItem: {
      type: Object,
      required: true,
    },
    config: {
      type: Object,
      required: true,
    },
    startType: {
      type: String,
      required: true,
    },
    insertAllowedType: {
      type: Array,
      required: true,
    },
    hideModel: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: false,
      showRightMenu: false,
      showCopy: false,
      showDelete: false,
      tableData: [{}, {}, {}, {}, {}],
      treeData: [],
      tableColumns: [],
      footer: {
        Inspectors: "",
        AppraiserDate: "",
        Verifiers: "",
        VerifierDate: "",
      },
    };
  },
  computed: {
    insertAllowed() {
      return this.insertAllowedType.includes(this.startType);
    },
    maxColspan() {
      let maxTdCount = 0;

      for (const trItem of this.record.trs) {
        if (trItem.tds.length > maxTdCount) {
          maxTdCount = trItem.tds.length;
        }
      }

      return maxTdCount > 0 ? maxTdCount : 1; // 最小合并数为1
    },
  },
  created() {
    // console.info("lay",this.record)
  },
  components: {
    formNode,
    draggable,
    CheckboxItem,
    RadioItem,
    TreeTest,
  },
  mounted() {
    console.log(this.record, "layoutItem========record");
  },
  methods: {
    getMaxColumns() {
      let maxColumns = 0;
      this.record.trs.forEach((trItem) => {
        const tdCount = trItem.tds.length;
        if (tdCount > maxColumns) {
          maxColumns = tdCount;
        }
      });
      return maxColumns;
    },
    getColspan(tdCount, tdIndex) {
      const maxColumns = this.getMaxColumns();
      if (tdCount === 1) {
        return maxColumns;
      } else {
        const remainingColumns = maxColumns - tdCount;
        const averageColspan = Math.floor(remainingColumns / (tdCount - 1));
        return averageColspan > 1 ? averageColspan + 1 : 1;
      }
    },

    // e, record, trIndex, tdIndex
    handleShowRightMenu(e, record, trIndex, tdIndex) {
      this.$emit("handleShowRightMenu", e, record, index, tdIndex);
    },
    handleSelectItem(record) {
      this.$emit("handleSelectItem", record);
    },
    // handleColAdd(event, tdItem, trIndex, tdIndex) {
    //   // 如果单元格中已经有一个组件，则阻止添加新组件
    //   if (tdItem.list.length > 0) {
    //     event.preventDefault(); // 阻止事件默认行为，即阻止添加组件
    //     this.$emit('showMessage', '每个单元格只允许一个组件');
    //   } else {
    //     // 如果单元格为空，则允许添加组件
    //     this.$emit('handleColAdd', event, tdItem.list);
    //   }
    // },
    handleColAdd(e, list) {
      this.$emit("handleColAdd", e, list);
    },
  },
};
</script>
